import { create } from "zustand";

// types
import { MenuProps } from "types/menu";

// ── store ──────────────────────────────────────────────────────────────────────
interface MenuStore {
  menuMaster: MenuProps;
  setDrawerOpen: (open: boolean) => void;
  setComponentDrawerOpen: (open: boolean) => void;
}

const useMenuStore = create<MenuStore>((set) => ({
  menuMaster: {
    isDashboardDrawerOpened: false,
    isComponentDrawerOpened: true,
  },
  setDrawerOpen: (open) =>
    set((state) => ({
      menuMaster: { ...state.menuMaster, isDashboardDrawerOpened: open },
    })),
  setComponentDrawerOpen: (open) =>
    set((state) => ({
      menuMaster: { ...state.menuMaster, isComponentDrawerOpened: open },
    })),
}));

// ── public API — same shape as before, callers unchanged ──────────────────────
export function useGetMenuMaster() {
  const menuMaster = useMenuStore((s) => s.menuMaster);
  return { menuMaster, menuMasterLoading: false };
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  useMenuStore.getState().setDrawerOpen(isDashboardDrawerOpened);
}

export function handlerComponentDrawer(isComponentDrawerOpened: boolean) {
  useMenuStore.getState().setComponentDrawerOpen(isComponentDrawerOpened);
}
